import Utilities from "./Utilities";

/**
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 *
 * @class com.omniapp.util.DateExt
 */

var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
        timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        timezoneClip = /[^-+\dA-Z]/g,
        pad = function (val, len) {
            val = String(val);
            len = len || 2;
            while (val.length < len) val = "0" + val;
            return val;
        };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
        var dF = dateFormat;

        // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
        if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
            mask = date;
            date = undefined;
        }

        // Passing date through Date applies Date.parse, if necessary
        date = date ? new Date(date) : new Date;
        if (isNaN(date)) throw SyntaxError("invalid date");

        mask = String(dF.masks[mask] || mask || dF.masks["default"]);

        // Allow setting the utc argument via the mask
        if (mask.slice(0, 4) == "UTC:") {
            mask = mask.slice(4);
            utc = true;
        }

        var _ = utc ? "getUTC" : "get",
            d = date[_ + "Date"](),
            D = date[_ + "Day"](),
            m = date[_ + "Month"](),
            y = date[_ + "FullYear"](),
            H = date[_ + "Hours"](),
            M = date[_ + "Minutes"](),
            s = date[_ + "Seconds"](),
            L = date[_ + "Milliseconds"](),
            o = utc ? 0 : date.getTimezoneOffset(),
            flags = {
                d:    d,
                dd:   pad(d),
                ddd:  dF._locale.dayNames[D],
                dddd: dF._locale.dayNames[D + 7],
                m:    m + 1,
                mm:   pad(m + 1),
                mmm:  dF._locale.monthNames[m],
                mmmm: dF._locale.monthNames[m + 12],
                yy:   String(y).slice(2),
                yyyy: y,
                h:    H % 12 || 12,
                hh:   pad(H % 12 || 12),
                H:    H,
                HH:   pad(H),
                M:    M,
                MM:   pad(M),
                s:    s,
                ss:   pad(s),
                l:    pad(L, 3),
                L:    pad(L > 99 ? Math.round(L / 10) : L),
                t:    H < 12 ? "a"  : "p",
                tt:   H < 12 ? "am" : "pm",
                T:    H < 12 ? "A"  : "P",
                TT:   H < 12 ? "AM" : "PM",
                Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
            };

        return mask.replace(token, function ($0) {
            return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
        });
    };
}();

var locale = function(l) {
    dateFormat._locale = dateFormat.i18[l];
}
/**
 * actuellement on veut parser
 * 10/04/1927          dd/MM/yyyy
 * 1927-04-03          yyyy-MM-dd
 * 1927-04-03 15:32:12 yyyy-MM-dd HH:mm:ss
 * 15:32:12            HH:mm:ss
 *
 * @param date a date as a string
 * @param format pattern of date
 */
var parseDate = function(date, format) {

    var patterns = {
        'y':2,
        'yy':2,
        'yyyy':4,
        'mm':2,
        'd':2,
        'dd':2,
        'HH':2,
        'hh':2,
        'MM':2,
        'ss':2
    };
    var d = new Date();

    var updateDate = function(val, pattern) {
        //Log.debug("update date, pattern='" + pattern + "' parsed='" + val + "'");
        switch (pattern) {
            case 'yyyy': d.setYear(val); break;
            case 'mm': d.setMonth(val - 1); break;
            case 'dd': d.setDate(val); break;
            case 'HH' : d.setHours(val); break;
            case 'MM' : d.setMinutes(val); break;
            case 'ss' : d.setSeconds(val); break;
        }
    };
    // Log.debug("parsing " + date + " with pattern '" + format + "'");
    for (var i = 0 ; i < format.length ;) {
        var pat = null;
        var parsed = null;
        var j = i+1;
        for (; j < format.length + 1; j++) {
            parsed = format.substring(i, j);
            if (patterns[parsed])
                pat = format.substring(i, j);
        }
        if (pat != null) {
           // Log.debug("use pattern '" + pat + "'");
            updateDate(parseInt(date.substring(i, i + pat.length)), pat);
        }
        else {
            // Log.debug("skip " + parsed.substring(0, 1));
        }
        i += (pat == null ? 1 : pat.length);
    }
    return d;
};
// Some common format strings
dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

dateFormat.i18n = {};

dateFormat.i18n.fr = {
    dayNames: [
        "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam",
        "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"
    ],
    monthNames: [
        "Jan", "Fev", "Mar", "Avr", "Mai", "Jui", "Jul", "Aou", "Sep", "Oct", "Nov", "Dec",
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ]
};

// Internationalization strings
dateFormat.i18n.en = {
    dayNames: [
        "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
};
dateFormat._locale = dateFormat.i18n.en;

// For convenience...
Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
};
Date.parseDate = parseDate;

// export default dateFormat;

